<div class="flex items-center space-x-16">
  <p class="mt-3" id="srs-last-updated">{{ lastUpdated }}</p>
  <button
    *ngIf="isEligible && isUserPmOrAboveOrHoSD && ballotInOpenOrDecisionPendingStatus"
    class="text-darkBlue-600 bg-transparent border-none p-0 cursor-pointer"
    id="Single-SRS-Proxy-Vote-Button"
    (click)="openProxyVoteModal()"
  >
    Proxy Vote
  </button>
</div>
